const apiBase = process.env.REACT_APP_ZOOM_API_BASE || '';

async function post(path, body) {
  const res = await fetch(`${apiBase}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `Request to ${path} failed`);
  }
  return res.json();
}

async function get(path) {
  const res = await fetch(`${apiBase}${path}`);
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `Request to ${path} failed`);
  }
  return res.json();
}

// ---------------------------------------------------------------------------
// Schedule
// ---------------------------------------------------------------------------

/** Fetch the class schedule with live session status for each class. */
export async function getSchedule() {
  return get('/api/zoom/schedule');
}

// ---------------------------------------------------------------------------
// Session lifecycle
// ---------------------------------------------------------------------------

/**
 * Create a new Zoom meeting for a class (teacher/admin only).
 * Returns host credentials including ZAK and role=1 signature.
 * Idempotent: returns existing live session credentials if one is already running.
 */
export async function startSession({ classId, userName, userEmail }) {
  return post('/api/sessions/start', { classId, userName, userEmail });
}

/**
 * Get student credentials for a live session (role=0, no ZAK).
 * Throws if no live session exists for the class.
 */
export async function joinSession({ classId, userName, userEmail }) {
  return post('/api/sessions/join', { classId, userName, userEmail });
}

/**
 * End a live session. Called explicitly on teacher leave and via sendBeacon
 * on tab/window close.
 */
export async function endSession(sessionId) {
  return post('/api/sessions/end', { sessionId });
}

/**
 * Teacher keepalive — POST every 20s while in a meeting.
 * Server ends the session if heartbeats stop for 60s+.
 */
export async function heartbeat(sessionId) {
  return post('/api/sessions/heartbeat', { sessionId });
}

/**
 * Poll session status for a class.
 * Returns { status: 'live'|'idle', joinable: bool, sessionId?, recordingUrl? }
 */
export async function getSessionStatus(classId) {
  return get(`/api/sessions/status/${encodeURIComponent(classId)}`);
}
